import { Formik } from 'formik'
import { qrLinkUpdateSchema } from 'src/common/validations'

import { useUpdateProductQrLink } from 'src/hooks'
import { IUpdateAccountOverrideUrlForm, IUpdateProductOverrideUrlForm } from 'src/types'
import { UpdateQrLinkForm } from './update-qr-link-form.component'
import { useUpdateAccountQrLink } from 'src/hooks/accounts/use-update-account-qr-link.hook'

interface IProps {
  handleClose: () => void
  accountId: string
  url: string | null
  lngCode: string
}

export const ModalInner = ({ handleClose, accountId, url, lngCode }: IProps) => {
  const { mutateAsync: updateQrLink } = useUpdateAccountQrLink()

  const handleSubmit = async (values: IUpdateAccountOverrideUrlForm) => {
    const resp = await updateQrLink({
      id: accountId,
      overrideUrl: values.overrideUrl,
      code: lngCode,
    })
    if (!resp) return
    handleClose()
  }

  return (
    <Formik
      initialValues={{ overrideUrl: url }}
      onSubmit={handleSubmit}
      validationSchema={qrLinkUpdateSchema}
    >
      <UpdateQrLinkForm />
    </Formik>
  )
}
